import React, { useState } from "react";
import "./feedback-form.scss";
import StarRating from "../star-rating/star-rating";
import axios from "axios";
import { toast } from "react-toastify";
import {
  userSessionStateSelector,
} from "../../redux/reducers/user-session/userSessionSlice";
import { useAppSelector } from "../../hooks/typed-hooks";

interface FeedbackFormProps {
  onClose: () => void;
}

const FeedbackForm: React.FC<FeedbackFormProps> = ({ onClose }) => {

  let apiUrlBase = process.env.REACT_APP_API_URL || "https://trowelwa01.azurewebsites.net/api/";
  // Ensure apiUrl ends with a slash
  if (!apiUrlBase.endsWith('/')) {
    apiUrlBase += '/';
  }

  // let apiUrlBase: string | undefined = process.env.REACT_APP_API_URL;
  // if (!apiUrlBase) {
  //   // Fallback value for prod environment
  //   apiUrlBase = "https://trowelwa01.azurewebsites.net/";
  // }

  const [rating, setRating] = useState<number>(0); // State to store the selected rating
  const [feedback, setFeedback] = useState({
    likes: "",
    frustrations: "",
    insights: "",
  });
  const [error, setError] = useState<string>("");
  const userSessionInfo = useAppSelector(userSessionStateSelector);

  const [showThankYou, setShowThankYou] = useState(false);

  const handleRatingChange = (newRating: number) => {
    setRating(newRating);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFeedback((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    // Validate form inputs
    if (
      !rating ||
      !feedback.likes ||
      !feedback.frustrations ||
      !feedback.insights
    ) {
      setError("All fields are required, including the rating.");
      return;
    }

    setError(""); // Clear any previous errors

    try {
      // Send data to the API
      const response = await axios.post(`${apiUrlBase}feedback/submit`, {
        rating,
        likes: feedback.likes,
        frustrations: feedback.frustrations,
        insights: feedback.insights,
        userId: userSessionInfo?.id, // Assuming userId is available in userSessionInfo
        userName: userSessionInfo?.name, // Assuming userName is available in userSessionInfo
        userEmail: userSessionInfo?.email, // Assuming userEmail is available in userSessionInfo
      });

      setShowThankYou(true);
      setTimeout(() => {
        setShowThankYou(false);
        console.log("Feedback submitted successfully:", response.data);
        //toast.success("Thank you for your feedback!");
        onClose(); // Close the form after successful submission
      }, 5000); // Show thank you message for 2 seconds
    } catch (error) {
      console.error("Error submitting feedback:", error);
      toast.error("Failed to submit feedback. Please try again.");
      setError("Failed to submit feedback. Please try again.");
    }
  };

  return (
    <div className="feedback-overlay">
      <div className="feedback-popup">
        <button className="feedback-close" onClick={onClose}>
          &times;
        </button>
        {!showThankYou ? (
          <>
            <span className="feedback-header">Share Your Feedback</span>
            <span className="feedback-subtitle">
              Let us know how we can enhance your experience with Trowel.AI.
            </span>
            <div className="feedback-form">
              <span className="experience-rating-header">
                Your Experience Rating
              </span>
              <StarRating rating={rating} onRatingChange={handleRatingChange} />

              <textarea
                name="likes"
                className="input-text-box-multi-line"
                rows={4}
                placeholder="What do you like most about our tool?"
                value={feedback.likes}
                onChange={handleInputChange}
              ></textarea>

              <textarea
                name="frustrations"
                className="input-text-box-multi-line"
                rows={4}
                placeholder="What frustrates you the most while using our tool?"
                value={feedback.frustrations}
                onChange={handleInputChange}
              ></textarea>

              <textarea
                name="insights"
                className="input-text-box-multi-line"
                rows={4}
                placeholder="How intuitive are the AI-generated insights?"
                value={feedback.insights}
                onChange={handleInputChange}
              ></textarea>
            </div>
            {error && <div className="error-message">{error}</div>}
            <div className="submit-button" onClick={handleSubmit}>
              Submit Feedback
            </div>
            <div className="do-it-later" onClick={onClose}>
              I will do it later
            </div>
          </>
        ) : (
          <div
            className="thank-you-message"
            style={{ textAlign: "center", padding: "2rem 1rem" }}
          >
            <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>👍</div>
            <div style={{ fontWeight: "bold", fontSize: "1.3rem" }}>
              Thank you for your feedback!
            </div>
            <div style={{ marginTop: "0.5rem" }}>
              We appreciate your input and will use it to improve your
              experience.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeedbackForm;
